import * as React from 'react'
import { useEffect } from 'react'
import { RelayEnvironmentProvider } from 'react-relay/hooks'
import {
  AppContextProvider,
  useTheme,
} from '@pareto-engineering/design-system'
import { useLocation } from 'react-router-dom'
import routes from 'modules/routes'
import appConfig from 'config'

import './main.scss'

import { Helmet } from 'react-helmet-async'
import { useUTMTracker, CookieBanner, SwitchRouteMap } from 'modules/components'
import ReactGA from 'react-ga4'

ReactGA.initialize(process.env.GA_TRACKING_ID)

const App = ({
  environment,
}) => {
  const { registerUTMSearchParameters } = useUTMTracker()

  useEffect(() => {
    registerUTMSearchParameters()

    const loaderElement = document.getElementById('loader')
    loaderElement.classList.add('loaded')
  }, [])
  const { userTheme } = useTheme()
  const hrefFavicon = `/favicon-${userTheme}.svg`

  const isClient = typeof window === 'object'
  const location = isClient
    ? useLocation()
    : {}

  useEffect(() => {
    if (isClient) {
      const page = location.pathname
      ReactGA.send({ hitType: 'pageview', page })
    }
  }, [location.pathname])

  return (
    <RelayEnvironmentProvider environment={environment}>
      <AppContextProvider
        config={appConfig}
      >
        <Helmet>
          <link rel="icon" href={hrefFavicon} />
        </Helmet>
        <SwitchRouteMap routes={routes} />
        <CookieBanner
          className={`ui-${userTheme === 'dark' ? 'dark' : 'light'}`}
          description="This website uses cookies to give you the best, most relevant experience."
          readMoreLink="/cookies"
        />
      </AppContextProvider>
    </RelayEnvironmentProvider>
  )
}

export default App
